class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('rebuy-modal-visible');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


if (!customElements.get("upsell-products")) {
  class UpsellProducts extends HTMLElement {
    constructor() {
      super();

      this.upsellList = this.querySelector('.upsell-products__list');
      this.switchButtons = this.querySelectorAll("[data-switch-action]")
      this.index;

      this.setupIntersectionObserver();
      this.setupSwitchButtons()

    }

    setupSwitchButtons() {
      this.switchButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          this.switchingCards(index)
        })
      });

    };

    switchingCards(index) {
      const cardWidth = this.upsellList.children[0].clientWidth;
      const gap = 15; // gap between cards
      const scrollAmount = cardWidth + gap;
      const currentScroll = this.upsellList.scrollLeft;
      const paddingLeft = 15;
      
      if (index === 0) {
        // Scroll left
        const newScroll = Math.max(0, currentScroll - scrollAmount);
        this.upsellList.scrollTo({ left: newScroll, behavior: 'smooth' });
      } else {
        // Scroll right
        const maxScroll = this.upsellList.scrollWidth - this.upsellList.clientWidth;
        const newScroll = Math.min(maxScroll, currentScroll + scrollAmount);
        this.upsellList.scrollTo({ left: newScroll, behavior: 'smooth' });
      }
    }

    setupIntersectionObserver() {
      const upsellObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.index = parseInt(entry.target.dataset.index);
              console.log(this.index);
              this.setActiveButton();
            }
          });
        },
        {
          threshold: 0.85,
        }
      );

      [...this.upsellList.children].forEach((card) => {
        upsellObserver.observe(card);
      });

    }
    setActiveButton() {
      let size = this.upsellList.children.length;
      this.index === 0
        ? (this.switchButtons[0]?.setAttribute('data-active', 'false'))
        : (this.switchButtons[0]?.setAttribute('data-active', 'true'));
      this.index === size - 1
        ? (this.switchButtons[1]?.setAttribute('data-active', 'false'))
        : (this.switchButtons[1]?.setAttribute('data-active', 'true'));
    }
  }

  customElements.define("upsell-products", UpsellProducts);
}


if (!customElements.get("upsell-button")) {
  class UpsellButton extends HTMLElement {
    constructor() {
      super();
      this.upsellProducts = this.closest("upsell-products");
      this.addEventListener('click', async (event) => {
        event.preventDefault();
        await this.addToCart(this.id, 1);
      });
    }

    async addToCart(variantId, quantity) {
      const res = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity
            }
          ]
        })
      });
      await this.render();
      return res;
    }

    async render() {
      const newHTML = await this.fetchSection();
      const parser = new DOMParser();
      let resAsHtml = parser.parseFromString(newHTML, 'text/html');
      const updatedCart = resAsHtml.querySelector('.cart-drawer');
      const currentContent = document.querySelector('.drawer__inner');
      const newContent = updatedCart.querySelector('.drawer__inner');
      document.querySelector('cart-drawer').classList.remove('is-empty');
      if (currentContent.innerHTML === newContent.innerHTML) return;
      currentContent.innerHTML = newContent.innerHTML;
      this.upsellProducts.setupSwitchButtons();
    }

    async fetchSection() {
      const res = await fetch(
        window.Shopify.routes.root + '?section_id=cart-drawer'
      );
      const text = await res.text();
      return text;
    }
  }

  customElements.define("upsell-button", UpsellButton);
}